<template>
  <Modal :hideExit="true" @cancel="closeModal" cClass="mw424">
    <template #header>
      <p class="typo-title1">{{ $t("page.btnCreate.modal.titleHeader", { type: $tc(`page.${type == "subpages" ? "landingpages" : type}`, 1) }) }}</p>
    </template>
    <template #default>
      <template>
        <div class="col-12 p-0">
          <div class="form-group">
            <label class="typo-body2 label text-black1">
              {{ $t("page.btnCreate.modal.title1", { type: $tc(`page.${type == "subpages" ? "landingpages" : type}`, 1) }) }}
            </label>
            <input ref="inputTitle" class="input-field input-field-border input-field-block" type="text" v-focus @keyup.enter="createPage" v-model="pageName" :placeholder="$t('page.btnCreate.modal.placeholder1', { type: $tc(`page.${type == 'subpages' ? 'landingpages' : type}`, 1) })" />
            <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertText }}</p>
          </div>
        </div>
        <div class="col-12 p-0">
          <div class="form-group mt-3 d-flex">
            <div class="d-flex">
              <p class="typo-button14 typo-medium text-light-high mr-1">{{ $t("generals.headerFooter") }}</p>
            </div>
            <div class="d-flex mt-2">
              <div>
                <!-- <Toggler class="mr-auto" v-model="headerFooter" :disabled="shopInfo.plan == 'starter'" /> -->
                <Toggler class="mr-auto" v-model="headerFooter" />
              </div>
              <p class="typo-paragraph14 typo-italic text-light-low ml-3">{{ $t("page.toggleDesc") }}</p>
            </div>
            <div class="mt-2">
              <div class="hf-image">
                <img v-if="headerFooter" :src="publicPath + require('@/core/assets/setting/headerFooterOn.svg')" />
                <img v-else :src="publicPath + require('@/core/assets/setting/headerFooterOff.svg')" />
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-12 p-0">
              <div class="form-group mt-3">
                <label class="typo-body2 label text-black1">Add to Group</label>
                <input
                  ref="inputTitle"
                  class="input-field input-field-border input-field-block"
                  type="text"
                  placeholder="Group name..."
                />
              </div>
        </div>-->
      </template>
    </template>
    <template #footer>
      <div class="btn-group flex-row-reverse">
        <template>
          <ProcessButton class="btn-primary ml-2" :status.sync="btnStatus" @click="createPage" type="submit">
            <template #loading>{{ $t("generals.loading") }}...</template>
            <template #successLoading>{{ $t("generals.redirecting") }}...</template>
            <template #error>{{ $t("generals.error") }}</template>
            <template #default>{{ $t("generals.create") }}</template>
          </ProcessButton>
        </template>

        <button class="btn btn btn-outline" @click="closeModal">{{ $t("generals.cancel") }}</button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { ProcessButton } from "@/core/shared";
import { mapActions, mapState } from "vuex";

export default {
  name: "ModalCreatePage",
  components: {
    ProcessButton
  },
  props: {
    type: {
      type: String,
      default: "subpages"
    },
    shop: String,
    template: [String, Number],
    plan: String,
    defaultName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      pageName: "",
      btnStatus: {
        loading: false,
        success: false,
        error: false,
        successLoading: false
      },
      headerFooter: true,
      alertText: ""
    };
  },
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo"
    })
  },
  created() {
    this.pageName = this.defaultName;
  },
  methods: {
    ...mapActions("page", {
      newPage: "newPage"
    }),
    closeModal() {
      this.$store.commit("account/IS_MODAL_VIEWING", false);
      this.$emit("close");
    },
    createPage() {
      if (!this.pageName) {
        this.alertText = this.$t("error.blankName");
        return;
      }
      this.alertText = "";
      this.btnStatus.loading = true;
      this.newPage({
        params: {
          pageLayout: this.headerFooter ? "default" : "blank",
          templateId: this.template,
          pageTitle: this.pageName
        },
        type: this.type,
        onSuccess: data => {
          this.btnStatus.loading = false;
          this.btnStatus.successLoading = true;

          window.location.href = data.editUrl;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.hf-image {
  min-height: 165px;
}
</style>
